import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getOtherOptionsFromWindow } from "../../utils";
import { getUserDecision } from "../getUserDecision";
/**
 * Read the selected groups + cookies depending on the passed type.
 *
 * @param type If "consent" it will be read from the current cookie and if this fails, it
 *             falls back to essentials-only.
 */

function getSelectedCookies(type) {
  var selectedGroups;

  var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
      groups = _getOtherOptionsFromW.groups,
      essentialGroup = _getOtherOptionsFromW.essentialGroup,
      setCookiesViaManager = _getOtherOptionsFromW.setCookiesViaManager,
      isPro = _getOtherOptionsFromW.isPro;

  var isManagerActive = isPro && setCookiesViaManager !== "none";

  var _groups$filter = groups.filter(function (_ref) {
    var slug = _ref.slug;
    return slug === essentialGroup;
  }),
      _groups$filter2 = _slicedToArray(_groups$filter, 1),
      essentialGroupObj = _groups$filter2[0];

  var consentEssentials = _defineProperty({}, essentialGroupObj.id, essentialGroupObj.items.map(function (_ref2) {
    var id = _ref2.id;
    return id;
  })); // Read current consent


  if (type === "consent") {
    var decision = getUserDecision();

    if (decision !== false) {
      selectedGroups = decision.consent;
    } else {
      console.warn("Something went wrong while reading the cookie, fallback to essentials only...");
      selectedGroups = consentEssentials;
    }
  }

  if (type === "essentials") {
    selectedGroups = consentEssentials;
  }

  return {
    isManagerActive: isManagerActive,
    selectedGroups: selectedGroups,
    iterateCookies: function () {
      var _iterateCookies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(callback) {
        var _iterator, _step, _group, _iterator2, _step2, _selectedGroups$_grou, _cookie, _isOptIn;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iterator = _createForOfIteratorHelper(groups);
                _context.prev = 1;

                _iterator.s();

              case 3:
                if ((_step = _iterator.n()).done) {
                  _context.next = 25;
                  break;
                }

                _group = _step.value;
                _iterator2 = _createForOfIteratorHelper(_group.items);
                _context.prev = 6;

                _iterator2.s();

              case 8:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 15;
                  break;
                }

                _cookie = _step2.value;
                _isOptIn = type === "all" || ((_selectedGroups$_grou = selectedGroups[_group.id]) === null || _selectedGroups$_grou === void 0 ? void 0 : _selectedGroups$_grou.indexOf(_cookie.id)) > -1;
                _context.next = 13;
                return callback(_group, _cookie, _isOptIn);

              case 13:
                _context.next = 8;
                break;

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](6);

                _iterator2.e(_context.t0);

              case 20:
                _context.prev = 20;

                _iterator2.f();

                return _context.finish(20);

              case 23:
                _context.next = 3;
                break;

              case 25:
                _context.next = 30;
                break;

              case 27:
                _context.prev = 27;
                _context.t1 = _context["catch"](1);

                _iterator.e(_context.t1);

              case 30:
                _context.prev = 30;

                _iterator.f();

                return _context.finish(30);

              case 33:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 27, 30, 33], [6, 17, 20, 23]]);
      }));

      function iterateCookies(_x) {
        return _iterateCookies.apply(this, arguments);
      }

      return iterateCookies;
    }()
  };
}

export { getSelectedCookies };